import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from 'react-bootstrap';
import { StandardButton } from '../Button';



const ConfirmModal = ({ title, closeText, onClose, submitText, onSubmit, children }) => {

  const handleSubmit = () => {
    if (onSubmit)
      onSubmit()
  }

  const handleClose = () => {
    if (onClose)
      onClose()
  }

      return (
        <Modal style={{position: "absolute", zIndex: "10000"}} show={true} onHide={handleClose} backdrop="static" keyboard={false} centered>
          <Modal.Header closeButton>
            <Modal.Title>{title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {children}
          </Modal.Body>
          <Modal.Footer>
            {closeText && (<StandardButton outlined onClick={handleClose}>
              {closeText}
            </StandardButton>)}
            {submitText && (<StandardButton onClick={handleSubmit}>
              {submitText}
            </StandardButton>)}
          </Modal.Footer>
        </Modal>

      )
}

      export default ConfirmModal;